module.exports = __webpack_public_path__ + "media/src/components/HomePage/HowItWorks/number-2-d1b25fd78d1daec65cbd5aa851ee7fa5.png";